/* eslint-disable no-unused-vars */
import apiService from '@/utils/api-client'
import config from '@/utils/appConfig'
import store from '@/store'

export default {
  getKYTList: async function (
    { commit },
    { $skip = undefined, $limit = undefined, configParams = {} },
  ) {
    try {
      return apiService.get('alert/lab/task', {
        params: { $skip, $limit },
        cancelToken: configParams.cancelToken,
        baseURL: config.VUE_APP_API_USERS_URL,
      })
    } catch (error) {
      console.error(error)
    }
  },
  getKYTById: async function ({ commit }, { taskId, configParams = {} }) {
    try {
      return apiService.get(`alert/lab/task/${taskId}`, {
        cancelToken: configParams.cancelToken,
        baseURL: config.VUE_APP_API_USERS_URL,
      })
    } catch (error) {
      console.error(error)
    }
  },
  async createKYTCase({ commit }, { ...payload }) {
    try {
      return apiService.post(
        'alert/lab/task',
        {
          ...payload,
        },
        { baseURL: config.VUE_APP_API_USERS_URL },
      )
    } catch (error) {
      console.error(error)
    }
  },
  async deleteKYTCase({ commit }, { id }) {
    try {
      return apiService.delete(`alert/lab/task/${id}`, {
        baseURL: config.VUE_APP_API_USERS_URL,
      })
    } catch (error) {
      console.error(error)
    }
  },
  getKYTTaskResults({ commit }, { taskId, $skip, $limit, status }) {
    try {
      return apiService.get(`/alert/lab/task/${taskId}/results`, {
        params: { $skip, $limit, status },
        baseURL: config.VUE_APP_API_USERS_URL,
      })
    } catch (error) {
      console.error(error)
    }
  },
}
